export const SIGNUP_STORAGE_KEYS = {
    EMAIL: 'signup.email',
    REF_CODE: 'signup.refCode',
    VERIFICATION_ID: 'signup.verificationId'
} as const
